__webpack_require__.p = "/2fa_deneme_uygulamasi/";